// initial state
const state = {
  overviewSettings: {}
}

// getters
const getters = {
  overviewSettings: (state) => (name) => {
    return state.overviewSettings[name]
  }
}

// mutations
const mutations = {
  overviewSettings (state, payload) {
    state.overviewSettings[payload.name] = payload.settings
  }
}

export default {
  state,
  getters,
  mutations
}
